export const fontFamilyList = [
    { text: 'Roboto', category: 'sans-serif', value: 'Roboto, sans-serif' },
    { text: 'Open Sans', category: 'sans-serif', value: 'Open Sans, sans-serif' },
    { text: 'Inter', category: 'sans-serif', value: 'Inter, sans-serif' },
    { text: 'Montserrat', category: 'sans-serif', value: 'Montserrat, sans-serif' },

    { text: 'IBM Plex Mono', category: 'monospace', value: 'IBM Plex Mono, monospace' },
    { text: 'Anonymous Pro', category: 'monospace', value: 'Anonymous Pro, monospace' },
];
